import { Form } from "@unform/web";

import Input from "Components/Admin/Form/Input";

const GlobalFilter = ({ column: { setFilter } }) => {
  return (
    <Form autoComplete="off">
      <Input
        size={"xs"}
        name="search"
        onChange={(e) => {
          setFilter(e.target.value || undefined);
        }}
        placeholder={`Pesquisar`}
        style={{
          fontSize: "0.8rem",
          border: "0",
        }}
      />
    </Form>
  );
};

export default GlobalFilter;
